// noinspection DuplicatedCode

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

// API
export const getPerbaikanTransaksi = createAsyncThunk(
  "perbaikanTransaksi/get",
  async ({ start, count, search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("start", start);
    formData.append("count", count);
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getPerbaikan",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const insertPerbaikanTransaksi = createAsyncThunk(
  "izinTransaksi/insert",
  async ({ Nik, Tanggal, Keterangan, JamMasuk, JamKeluar }, thunkAPI) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    formData.append("Tanggal", Tanggal);
    formData.append("Keterangan", Keterangan);
    formData.append("JamMasuk", JamMasuk);
    formData.append("JamKeluar", JamKeluar);

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertPerbaikan",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updatePerbaikanTransaksi = createAsyncThunk(
  "izinTransaksi/update",
  async ({ Nik, Tanggal, Keterangan, JamMasuk, JamKeluar }, thunkAPI) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    formData.append("Tanggal", Tanggal);
    formData.append("Keterangan", Keterangan);
    formData.append("JamMasuk", JamMasuk);
    formData.append("JamKeluar", JamKeluar);

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "updatePerbaikan",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const deletePerbaikanTransaksi = createAsyncThunk(
  "perbaikanTransaksi/delete",
  async ({ ID }, thunkAPI) => {
    let formData = new FormData();
    formData.append("ID", ID);

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "deletePerbaikan",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const resetIzinSlice = createAsyncThunk(
  "resetIzinSlice/update",
  async ({}, thunkAPI) => {
    return true;
  }
);
//INIT
const initialState = {
  message: "",
  SpecIzinData: [],
  isSpecIzinFetching: false,
  isSpecIzinSuccess: false,
  isSpecIzinError: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  errorMessage: "",
  report: [],
  reportDetail: null,
  isGetReport: false,
};

//SLICES
export const perbaikanTransaksiSlice = createSlice({
  name: "perbaikanTransaksi",
  initialState,
  reducers: {},
  extraReducers: {
    [resetIzinSlice.fulfilled]: (state, { payload }) => {
      state = initialState;
      return state;
    },

    // GET
    [getPerbaikanTransaksi.fulfilled]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetSuccess = true;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message;
      return state;
    },
    [getPerbaikanTransaksi.rejected]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetError = true;
      state.errorMessage = payload.message;
    },
    [getPerbaikanTransaksi.pending]: (state) => {
      state.isGetFetching = true;
    },

    // INSERT
    [insertPerbaikanTransaksi.fulfilled]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [insertPerbaikanTransaksi.rejected]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertError = true;
      state.errorMessage = payload.message;
    },
    [insertPerbaikanTransaksi.pending]: (state) => {
      state.isInsertFetching = true;
    },

    // UPDATE
    [updatePerbaikanTransaksi.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [updatePerbaikanTransaksi.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload.message;
    },
    [updatePerbaikanTransaksi.pending]: (state) => {
      state.isUpdateFetching = true;
    },
    [deletePerbaikanTransaksi.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [deletePerbaikanTransaksi.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload.message;
    },
    [deletePerbaikanTransaksi.pending]: (state) => {
      state.isUpdateFetching = true;
    },
  },
});

export const perbaikanTransaksiSelector = (state) => state.perbaikanTransaksi;
